<script setup lang="ts">
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'RegisterButton2',

    data() {
        return {
        }
    },

    mounted(): void
    {
        const button = this.$refs.registerButton

        if (button instanceof HTMLElement) {
            setTimeout(() => {
                button.classList.add('active')

                setInterval(() => {
                    button.classList.contains('maxOpen')
                        ? button.classList.remove('maxOpen')
                        : button.classList.add('maxOpen')
                }, 2000)
            }, 500)
        }
    }
})
</script>

<template>
    <router-link class="registerButton noselect" to="register">
        <div class="content" ref="registerButton">
            <div class="doorLeaf top"/>
            <div class="doorLeaf bottom"/>
            <div class="background absolute-fill">
                <div class="label">Регистрация</div>
            </div>
        </div>
    </router-link>
</template>

<style scoped lang="scss">
.registerButton {
    position: relative;
    background: black;
    box-shadow: 0 0 10px 1px black;
    border-radius: 10px;
    cursor: pointer;
    margin: 0 auto;
    width: 430px;
    max-width: 430px;
    min-width: 430px;
    min-height: 60px;
    height: 60px;
    text-decoration: none;
    overflow: hidden !important;
    border: 1px solid black;
    transition: scale 0.2s ease;

    .content {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .doorLeaf {
            background: linear-gradient(
                    135deg,
                    rgb(255, 184, 45) 0%,
                    rgba(30,30,30,1) 0.2%,
                    rgba(30,30,30,1) 5%,
                    rgb(255, 184, 45) 5.2%,
                    rgb(255, 184, 45) 10%,
                    rgba(30,30,30,1) 10.2%,
                    rgba(30,30,30,1) 15%,
                    rgb(255, 184, 45) 15.2%,
                    rgb(255, 184, 45) 20%,
                    rgba(30,30,30,1) 20.2%,
                    rgba(30,30,30,1) 25%,
                    rgb(255, 184, 45) 25.2%,
                    rgb(255, 184, 45) 30%,
                    rgba(30,30,30,1) 30.2%,
                    rgba(30,30,30,1) 35%,
                    rgb(255, 184, 45) 35.2%,
                    rgb(255, 184, 45) 40%,
                    rgba(30,30,30,1) 40.2%,
                    rgba(30,30,30,1) 45%,
                    rgb(255, 184, 45) 45.2%,
                    rgb(255, 184, 45) 50%,
                    rgba(30,30,30,1) 50.2%,
                    rgba(30,30,30,1) 55%,
                    rgb(255, 184, 45) 55.2%,
                    rgb(255, 184, 45) 60%,
                    rgba(30,30,30,1) 60.2%,
                    rgba(30,30,30,1) 65%,
                    rgb(255, 184, 45) 65.2%,
                    rgb(255, 184, 45) 70%,
                    rgba(30,30,30,1) 70.2%,
                    rgba(30,30,30,1) 75%,
                    rgb(255, 184, 45) 75.2%,
                    rgb(255, 184, 45) 80%,
                    rgba(30,30,30,1) 80.2%,
                    rgba(30,30,30,1) 85%,
                    rgb(255, 184, 45) 85.2%,
                    rgb(255, 184, 45) 90%,
                    rgba(30,30,30,1) 90.2%,
                    rgba(30,30,30,1) 95%,
                    rgb(255, 184, 45) 95.2%
            );

            z-index: 100;
            position: absolute;
            left: 0;
            right: 0;
            height: 40px;
            transition: all 0.2s ease;

            &.top {
                //top: -30px;
                top: -10px;
                left: -62px;
                box-shadow: inset 0 0 3px 1px black;
            }
            &.bottom {
                box-shadow: inset 0 0 3px 1px black;
                //bottom: -30px;
                bottom: -10px;
                right: -62px;
            }
        }

        .background {
            position: absolute;
            z-index: 0;
            border: 1px solid #161616;
            box-sizing: content-box;
            box-shadow: inset 0 0 15px 11px black;
            background: black;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.5s ease-in;
        }

        .label {
            position: relative;
            z-index: 1000;
            color: #d8ffef;
            font-size: 20px;
            text-shadow: 0 0 5px black;
            transition: color 0.1s ease-in;
        }

        &.active {
            .doorLeaf.top {
                top: -31px;
            }
            .doorLeaf.bottom {
                bottom: -31px;
            }

            .background {
                box-shadow: inset 0 0 15px 11px #0076a8;
                background: #00a682;
            }
        }

        &.maxOpen,
        &:hover {
            .doorLeaf.top {
                top: -37px;
                border-bottom: 1px solid black;
            }

            .doorLeaf.bottom {
                bottom: -37px;
                border-top: 1px solid black;
            }
        }

        &:hover {
            .background {
                background: #00daa8;
                transition: background-color 0.3s ease;
            }

            .label {
                color: white;
            }
        }
    }

    &:active {
        .content {
            .background {
                background: #00ffc6;
                transition: background-color 0.01s ease;
            }
        }
    }
}
</style>
